import * as React from 'react';
import ApiDocs from '../../../../../components/api-docs/api-docs';

export default function ApiDocsPartnerOfficeScreen() {
  return <ApiDocs />;
}
